<oui-searchbar
  class="width-100pc padding-vertical-16"
  placeholder="Rechercher"
  [control]="searchControl"
  iconPrefix="search">
</oui-searchbar>

@if (requestResult?.data?.totalCount > 0) {
  <div class="margin-top-8 margin-bottom-8">{{ requestResult?.data?.totalCount }} Investisseurs suggérés</div>
}
@if (requestResult?.data?.totalCount > 0) {
  <app-add-relation-table
    [(paginationParams)]="paginationParams"
    [inputData]="requestResult"
    [tooltipName]="'signataire'"
    (addRelation)="addSignataire.emit($event)">
  </app-add-relation-table>
} @else {
  <div class="text-center">Aucun signataire trouvé</div>
}
